import * as React from 'react';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import {
    SmartComposeAriaAnnouncementPrefix,
    SmartComposeAriaAnnouncementPostfix,
} from './SmartComposeAriaLiveRegion.locstring.json';
import getShouldShowTabHint from '../utils/getShouldShowTabHint';

export interface SmartComposeAriaLiveRegionProps {
    suggestion: string;
}

export default observer(function SmartComposeAriaLiveRegion(
    props: SmartComposeAriaLiveRegionProps
) {
    const { suggestion } = props;

    let announcement: string = '';

    if (suggestion) {
        const prefix: string = loc(SmartComposeAriaAnnouncementPrefix);
        const postfix: string = loc(SmartComposeAriaAnnouncementPostfix);
        announcement = getShouldShowTabHint() ? prefix + suggestion + postfix : prefix + suggestion;
    }

    return (
        <div
            role={'status'}
            aria-live={'polite'}
            aria-label={announcement}
            aria-atomic={'true'}></div>
    );
});
